import styled, { css } from 'react-emotion'
import { color, shadow, spacer } from 'stylist'

const uploaderStyle = ({ theme, isUploader }) =>
  isUploader &&
  css`
    ${shadow('distant', { theme })};

    > div {
      height: 100%;
      border: none;
      background-color: ${color('ocean', { theme })};
      color: ${color('white', { theme })};
      &:hover {
        background-color: ${color('ocean', { theme })} !important;
        opacity: 0.9;
      }
    }
    > div a {
      color: ${color('white', { theme })};
    }
  `

const videoStyle = ({ isVideo, theme }) =>
  isVideo &&
  css`
    ${shadow('distant', { theme })};
  `

const TileContainer = styled.div`
  background-color: ${({ processing, failed }) =>
    processing || failed ? color('white') : color('slate')};
  overflow: hidden;
  position: relative;
  border-radius: ${spacer('1')};
  ${videoStyle};
  ${uploaderStyle};
`

export default TileContainer



// WEBPACK FOOTER //
// ./src/routes/videos/components/TileContainer.js